import { useTranslation } from "react-i18next";
import BudgetsByCategory from "./components/budgets-by-category";
import Header from "./components/header";
import SummaryCard from "./components/summary-card";
import { useGetBudgetSummaries } from "@/services/queries/budgets";
import { useEffect, useMemo } from "react";
import useBudgets from "@/store/use-budgets";

const Budgets = () => {
  const { t } = useTranslation();
  const { data } = useGetBudgetSummaries();
  const { currentBudget, setCurrentBudget } = useBudgets();

  const budgetSummaries = useMemo(() => {
    return data?.value ?? [];
  }, [data?.value]);

  useEffect(() => {
    if (budgetSummaries.length > 0 && !currentBudget) {
      setCurrentBudget(budgetSummaries[0]);
    }
  }, [budgetSummaries, currentBudget, setCurrentBudget]);

  return (
    <>
      <title>{t("title.budget")}</title>
      <div>
        <Header />
        <SummaryCard budgetSummaries={budgetSummaries} />
        <BudgetsByCategory />
      </div>
    </>
  );
};

export default Budgets;
